// extracted by css-extract-rspack-plugin
export default {"statusCell":"statusCell-CYPtCx","actionsIcon":"actionsIcon-fxMRub"};